import { useHasAnyRole } from '@/hooks/auth';
import { useSettings } from '@/hooks/state/useSettings';
import { FileFormat } from '@/types/file-format';
import { useMemo } from 'react';

/**
 * Hook to determine if user is eligible for file format preferences and their default format
 * @returns Object with eligibility status and default file format
 */
export const useFileFormatEligible = () => {
  const settingsResult = useSettings();
  const settings = settingsResult?.settings;
  const isEligibleUser = useHasAnyRole(['Pro', 'Business']);

  const defaultFormat = useMemo(
    () =>
      isEligibleUser
        ? (settings?.preferences?.file_format ?? FileFormat.AskEveryTime)
        : FileFormat.MP3,
    [isEligibleUser, settings?.preferences?.file_format]
  );

  return {
    isEligibleUser,
    defaultFormat,
  };
};
